import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs

// Components
import Image from '@/components/common/Image'

// Constants

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface EmptyProps {
  type: 'explore' | 'follow' | 'following' | 'followers'
}

const Empty = (props: EmptyProps) => {
  const { t } = useTranslation()

  const { type = 'explore' } = props
  const emptyConfig = {
    explore: {
      imageUrl: '/images/livemall-empty/explore.png',
      title: t('Empty_Explore_Title'),
      description: t('Empty_Explore_Description'),
    },
    follow: {
      imageUrl: '/images/livemall-empty/follow.png',
      title: t('Empty_Follow_Title'),
      description: t('Empty_Follow_Description'),
    },
    following: {
      imageUrl: '/images/livemall-empty/following.png',
      title: t('Empty_Following_Title'),
      description: t('Empty_Following_Description'),
    },
    followers: {
      imageUrl: '/images/livemall-empty/followers.png',
      title: t('Empty_Followers_Title'),
      description: t('Empty_Following_Description'),
    },
  }

  const { imageUrl, title, description } = emptyConfig[type]

  return (
    <div className={cx('empty')}>
      <div className={cx('empty-icon')}>
        <Image src={imageUrl} fill alt='empty' />
      </div>
      <div className={cx('empty__content')}>
        <h4 className={cx('empty__content-title')}>{title}</h4>
        <h4 className={cx('empty__content-description')}>{description}</h4>
      </div>
    </div>
  )
}

export default Empty
